import _typeof from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof";
var _jsxFileName = "/repo/packages/ippm/src/utils/appContext.js",
  _this = this;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useContext, createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { t } from '@sm/intl';
import { PLAN_TYPES } from '../constants/plans';
import IPPM_COPY from '../constants/ippmString';
var AppContext = /*#__PURE__*/createContext();

// AppContext.propTypes = {
//   appData: PropTypes.shape().isRequired,
//   children: PropTypes.node,
// };

var getDisplayedPlanType = function getDisplayedPlanType(addedPaidFeatures) {
  if (addedPaidFeatures && addedPaidFeatures.includes('wall_share_surveys')) {
    return PLAN_TYPES.TEAMS;
  }
  return PLAN_TYPES.INDIVIDUAL;
};
var AppContextProvider = function AppContextProvider(_ref) {
  var appData = _ref.appData,
    strings = _ref.strings,
    children = _ref.children;
  var featureSetId = appData.featureSetId,
    addedPaidFeatures = appData.addedPaidFeatures;
  /*
  For legacy pythonwebs we want to maintain the ability to send strings as
  props into IppmApp for other Apps we will use @sm/intl for translations.
  */
  var getLocalString = function getLocalString(string) {
    return t(IPPM_COPY[string]);
  };

  /*
  Passed strings could either be formatted as
  {
    'string_name': 'string'
  }
  or
  {
    'string_name': {
      'id': 'string_id',
      'defaultMessage': 'string',
      'description': 'string_description'
    }
  }
  */
  var getPassedString = function getPassedString(string) {
    return _typeof(strings[string]) === 'object' ? strings[string].defaultMessage : strings[string];
  };
  var localStrings = Object.keys(strings).length === 0;
  var getString = localStrings ? getLocalString : getPassedString;
  var _useState = useState(getDisplayedPlanType(addedPaidFeatures, getString)),
    _useState2 = _slicedToArray(_useState, 2),
    displayedPlanType = _useState2[0],
    setDisplayedPlanType = _useState2[1];
  var appContextValue = useMemo(function () {
    var featureFlags = {
      isOnRbpFeatureSet: featureSetId === 67 || featureSetId === 68,
      standardMonthly500: featureSetId === 68,
      standardMonthly100: featureSetId === 67
    };
    var toggleDisplayedPlanType = function toggleDisplayedPlanType() {
      var newDisplayedPlanType = displayedPlanType === PLAN_TYPES.INDIVIDUAL ? PLAN_TYPES.TEAMS : PLAN_TYPES.INDIVIDUAL;
      setDisplayedPlanType(newDisplayedPlanType);
    };

    // mocked paidFeatureString in case its needed
    // paidFeatureString = paidFeaturesString;
    return _objectSpread(_objectSpread({}, appData), {}, {
      displayedPlanType: displayedPlanType,
      toggleDisplayedPlanType: toggleDisplayedPlanType,
      getString: getString,
      featureFlags: featureFlags
    });
  }, [appData, displayedPlanType, setDisplayedPlanType, getString, featureSetId]);
  return /*#__PURE__*/React.createElement(AppContext.Provider, {
    value: appContextValue,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 5
    }
  }, children);
};
AppContextProvider.defaultProps = {
  strings: {}
};
AppContextProvider.propTypes = {
  appData: PropTypes.shape().isRequired,
  strings: PropTypes.shape(),
  children: PropTypes.node.isRequired
};
export function useAppContext() {
  return useContext(AppContext);
}
export default AppContextProvider;